/**
 * Switches between the classic (sidebar) and tiles parent dashboard.
 *
 * ParentDashboardWrapper picks the classic view from `?classic=1`; the old
 * `dashboard_variant` localStorage key is still written for anything that
 * reads it, but on its own it no longer changes the view, so the buttons
 * also set or clear the query parameter.
 */
export function setDashboardVariant(variant: 'A' | 'B'): void {
  try {
    localStorage.setItem('dashboard_variant', variant)
  } catch {
    // Storage unavailable; the query parameter is what matters.
  }
  const url = new URL(window.location.href)
  if (variant === 'A') {
    url.searchParams.set('classic', '1')
  } else {
    url.searchParams.delete('classic')
  }
  window.location.assign(url.toString())
}
